import { Outlet, useLocation } from "react-router-dom";
import { Layout, theme } from "antd";
import HorizationHeader from "@/components/layout/HorizationHeader";
import VerticalCenteredSider from "@/components/layout/VerticalCenteredSider";
import { useEffect } from "react";

const { Content, Footer } = Layout;

const App = () => {
  const { token: { borderRadiusLG } } = theme.useToken();
  const location = useLocation(); // 获取当前路由信息

  // 判断是否为首页
  const isHomePage = location.pathname === '/' || location.pathname === '/home';

  // 未登录的重定向到商品页面
  useEffect(() => {
    if (window.location.pathname === '/' && !localStorage.getItem('token')) {
      window.location.href = '/home';
    }
  }, []);

  return (
    <Layout style={{
      height: '100vh',
      background: "linear-gradient(45deg, rgba(255, 255, 255, 0.3), #f8f9fa)"
    }}>
      <HorizationHeader />
      <Layout style={{ backgroundColor: "linear-gradient(45deg, rgba(255, 255, 255, 0.3), #f8f9fa)" }}>
        <VerticalCenteredSider />
        <Layout style={{ backgroundColor: "linear-gradient(45deg, rgba(255, 255, 255, 0.3), #f8f9fa)" ,marginTop:isHomePage?'0':'64px'}}>
          <Content
            style={{
              margin: isHomePage ? "0" : "0 15px ",
              borderRadius: isHomePage ? "0" : borderRadiusLG,
              overflowY: "auto",
            }} >
            <Outlet />
          </Content>
          <Footer
            style={{
              textAlign: "center",
              padding: 10,
              background: "linear-gradient(45deg, rgba(255, 255, 255, 0.3), #f8f9fa)",
            }}
          >
            © 2024 - {new Date().getFullYear()} 中吒科技（杭州）有限公司 版权所有 | <a style={{color: "rgba(0,0,0,0.88)"}} href='https://beian.miit.gov.cn/' target="_blank" >浙ICP备2025192556号-1</a>
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default App;